"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@services/display-logic/display-logic-request-params-manager");
require("@services/report-state/layout-engine/flowing-pages");
var context_meta_1 = require("@shared/types/context-meta");
var environment_1 = require("@shared/types/environment");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var SERVICE_NAME = 'prInitService';
(function (angularModule) {
    angularModule.factory('prInitService', [
        'rsEnvironment',
        'rsState',
        'rsWidgets',
        '$routeParams',
        '$timeout',
        '$interval',
        '$q',
        'rum',
        'pr.globalOptionsService',
        'pr.widgetStylesService',
        'prHeaderFooterService',
        'prActiveReport',
        'pr.widgetManager',
        'prSourceDataService',
        'prConditionalDisplay',
        '$http',
        'pr.API_ROUTES',
        'prFlowingPages',
        'prSectionManagerHelper',
        'pr.predefinedDataService',
        'pr.widgetConstants',
        'pr.customFilterService',
        'pr.editAbilityManager',
        'pr360RaterDisplayLogicService',
        'pr.navigationService',
        'pr.displayLogicParamsManager',
        'prDynamicTranslationsUtil',
        'pr.loggerService',
        'prHeaderFooterInitService',
        function (
        // @ts-ignore
        env, 
        // @ts-ignore
        rsState, 
        // @ts-ignore
        rsWidgets, 
        // @ts-ignore
        $routeParams, 
        // @ts-ignore
        $timeout, 
        // @ts-ignore
        $interval, 
        // @ts-ignore
        $q, 
        // @ts-ignore
        rum, 
        // @ts-ignore
        globalOptionsService, 
        // @ts-ignore
        widgetStylesService, 
        // @ts-ignore
        headerFooterService, 
        // @ts-ignore
        activeReport, 
        // @ts-ignore
        widgetManager, sourceData, 
        // @ts-ignore
        conditionalDisplay, 
        // @ts-ignore
        $http, 
        // @ts-ignore
        API_ROUTES, flowingPages, 
        // @ts-ignore
        sectionManagerHelper, 
        // @ts-ignore
        predefinedDataService, 
        // @ts-ignore
        widgetConstants, 
        // @ts-ignore
        customFilterService, editAbilityManager, 
        // @ts-ignore
        raterDisplayLogicService, 
        // @ts-ignore
        navigationService, displayLogicParamsManager, 
        // @ts-ignore
        dynamicTranslationsUtil, 
        // @ts-ignore
        loggerService, 
        // @ts-ignore
        pageHeaderFooterInitService) {
            var logger = loggerService.getLoggerManager(SERVICE_NAME);
            // @ts-ignore
            var containerDef;
            function checkAppReady() {
                var checkReady = $interval(function () {
                    try {
                        if (widgetManager.isReportReady()) {
                            rum.appInteractive();
                            $interval.cancel(checkReady);
                        }
                    }
                    catch (e) {
                        $interval.cancel(checkReady);
                    }
                }, 50);
            }
            function init() {
                setRSDKConfig();
                env.set(environment_1.ENV_VARS.RS_ACTIVE_SURVEY, $routeParams.surveyId);
                containerDef = env.get(environment_1.ENV_VARS.CONTAINER).definition;
                setupContainer();
                globalOptionsService.setDefaultMomentTimezone();
                sourceData.warmCache();
                customFilterService.register();
                editAbilityManager.init();
                dynamicTranslationsUtil.setMissingTranslationAttributes();
                initializeRipsawConfig();
                rum.appLoading();
                checkAppReady();
            }
            function setRSDKConfig() {
                widgetConstants.addRsdkWidgets();
            }
            // Fill ripsaw cache with all widget-states and apply styles
            function initWidgets() {
                return pageHeaderFooterInitService.recalculatePipedText().then(function () {
                    // @ts-ignore
                    return predefinedDataService.setupFilters().catch(function (error) {
                        console.error('Error setting up predefined filters', error);
                        // @ts-ignore
                    }).then(function (widgetStates) {
                        var pages = getPagesToLoad();
                        for (var _i = 0, pages_1 = pages; _i < pages_1.length; _i++) {
                            var p = pages_1[_i];
                            initWidgetsOfPage(p, widgetStates);
                        }
                        return initializeReportLanguage();
                    });
                });
            }
            function initializeReportLanguage() {
                // the report language must be initialized after rsState.setCachedState is called,
                // because dynamicTranslationsUtil may need to call rsState.clearCache afterwards.
                // TODO: we should consider removing calls to rsState.setCachedState altogether
                // @ts-ignore
                return dynamicTranslationsUtil.initializeReportLanguage().catch(function (error) {
                    var message = 'Failed to initialize report language';
                    logger.error({ message: message, error: error });
                });
            }
            function initWidgetsOfPage(page, widgetStates) {
                widgetStates = widgetStates || {};
                // @ts-ignore
                for (var _i = 0, _a = page.widgets; _i < _a.length; _i++) {
                    var widget = _a[_i];
                    var widgetState = widgetStates[widget._id] || widget.state || { privateData: {}, sharedData: {} };
                    widgetStylesService.applyAllWidgetStyles(widget);
                    // @ts-ignore
                    rsState.setCachedState(widget._id, page._id, containerDef._id, widgetState);
                    flowingPages.validateWidgetLayout(widget._id);
                }
            }
            function computeConditionalWidgets() {
                // @ts-ignore
                var promises = [];
                var pages = getPagesToLoad();
                for (var _i = 0, pages_2 = pages; _i < pages_2.length; _i++) {
                    var page = pages_2[_i];
                    var promisesOfPage = computeConditionalWidgetsOfPage(page);
                    // @ts-ignore
                    promises = promises.concat(promisesOfPage);
                }
                return $q.all(promises);
            }
            function computeConditionalWidgetsOfPage(page) {
                var promises = [];
                var _loop_1 = function (widget) {
                    var widgetState = widget.state || { privateData: {}, sharedData: {} };
                    var dataConfig = lodash_1.default.get(widgetState, 'sharedData.dataConfig');
                    if (dataConfig) {
                        var promise = conditionalDisplay.computeWidgetConditionalDisplay(widget._id, dataConfig)
                            // @ts-ignore
                            .then(function (displayLogicRequestParams) {
                            return displayLogicParamsManager.setDisplayLogicRequestParams(widget._id, displayLogicRequestParams);
                        }).catch(function (error) {
                            var message = "Unable to compute display logic for " + widget._id;
                            logger.error({ message: message, error: error });
                            // Suppress errors if in edit mode but throw an error in
                            // read only mode to prevent participants from seeing unauthorized data
                            if (navigationService.isReadOnly) {
                                throw new Error(message);
                            }
                        });
                        promises.push(promise);
                    }
                };
                // @ts-ignore
                for (var _i = 0, _a = page.widgets; _i < _a.length; _i++) {
                    var widget = _a[_i];
                    _loop_1(widget);
                }
                return promises;
            }
            function initSingleWidget(widgetId) {
                cacheSingleWidget(widgetId);
                return initializeReportLanguage();
            }
            // Fill ripsaw cache with single widget-states
            function cacheSingleWidget(singleWidgetId) {
                var widget;
                // @ts-ignore
                var pageOfWidget = lodash_1.default.find(containerDef.pages, function (page) {
                    return !!(widget = lodash_1.default.find(page.widgets, { _id: singleWidgetId }));
                });
                if (widget && pageOfWidget) {
                    // @ts-ignore
                    var widgetState = widget.state || { privateData: {}, sharedData: {} };
                    // @ts-ignore
                    // @ts-ignore
                    rsState.setCachedState(widget._id, pageOfWidget._id, containerDef._id, widgetState);
                }
            }
            function initializeRipsawConfig() {
                rsWidgets.setLoadStrategy(rsWidgets.LOAD_ALL_META_DATA);
                rsWidgets.ensureDependency('pr.product-base-component');
                rsWidgets.ensureDependency('eng.component-base');
            }
            function setupContainer() {
                // @ts-ignore
                env.set(environment_1.ENV_VARS.CONTAINER_ID, containerDef._id);
            }
            function complete() {
                activeReport.updateDocumentTitle();
                // we must reset the ui pages AFTER conditional display logic is calculated for each widget
                flowingPages.resetPages();
                $timeout(function () {
                    globalOptionsService.applyChartTextStyles();
                    globalOptionsService.applyBodyTextStyles();
                    globalOptionsService.applyTableHeaderTextStyles();
                    globalOptionsService.applyTableBodyTextStyles();
                    globalOptionsService.applyScaleColorPaletteColors();
                    headerFooterService.updateHeaderAndFooter();
                    rum.appComplete();
                });
            }
            function getSourcesUsedInReport() {
                var connectedSources = lodash_1.default.flatten(lodash_1.default.values(activeReport.getMetadata(context_meta_1.CONTEXT_META_VARS.CONNECTED_SOURCES)));
                var allSurveys = lodash_1.default.union([env.get(environment_1.ENV_VARS.RS_ACTIVE_SURVEY)], connectedSources);
                // @ts-ignore
                return $http.get(API_ROUTES.SOURCES + '?ids=' + allSurveys.join(',')).then(function (data) {
                    env.set(environment_1.ENV_VARS.SOURCES, data.data);
                    return data.data;
                });
            }
            function getPagesToLoad() {
                // @ts-ignore
                return sectionManagerHelper.getSectionsToLoad(containerDef.pages);
            }
            function shouldHideEntireReport() {
                if (navigationService.isEditor && !navigationService.isExport) {
                    return $q.when(false);
                }
                return raterDisplayLogicService.isEntireReportHidden();
            }
            return {
                init: init,
                initWidgets: initWidgets,
                initSingleWidget: initSingleWidget,
                complete: complete,
                getSourcesUsedInReport: getSourcesUsedInReport,
                computeConditionalWidgets: computeConditionalWidgets,
                shouldHideEntireReport: shouldHideEntireReport
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
